<template>
  <el-popover 
    v-if="details.star_rating && details.reason && details.ref_map" 
    trigger="hover"
    placement="right"
    popper-class="discount-panel-info-popover"
  >
    <img 
      src="@/assets/orderTest/order-page/order-test-panel/discount_red_tag.svg"
      alt="red tag"
      class="absolute right-4 -top-3 red-tag"
    >
    <div class="absolute right-5 top-1 w-20 rating">
      <p class="mb-2">{{ $t("OrderPage[\"Rating\"]") }}</p>
      <p>{{ Number(details.star_rating).toFixed(1) }}</p>
      <div class="flex justify-between px-1.5">
        <span v-for="index in Number(details.star_rating)" :key="index" class="material-icons-outlined star-icon">star</span>
      </div>
    </div>
    <p class="subtitle mt-5">{{ $t("OrderPage[\"Clinic Reason\"]") }}</p>
    <div class="content w-60 mt-1.5">{{ details.reason }}</div>
    <div class="flex mt-5">
      <p class="subtitle">{{ $t("OrderPage[\"Ref Link:\"]") }}</p>
      <a v-for="(url, index) in Object.values(details.ref_map)" :key="index" class="content" :href="url" target="_blank">
        Ref {{ index + 1 }},
      </a>
    </div>

    <!-- <div class="bundle-details mt-3.5">
      <p>Order Id: {{ bundle.bundleId }}</p>
      <p class="mt-2.5">
        Original Price: ${{ (
          bundle.originalPrice
            ? bundle.originalPrice
            : bundle.category === "customPanel"
              ? bundle.price
              : bundle.price 
        ).toFixed(2) }}
      </p>
      <p v-if="bundleTestNameList.length > 0" class="mt-2.5">
        Tests: {{ bundleTestNameList.join(", ") }}
      </p>
    </div> -->
    <template v-slot:reference>
      <img 
        src="@/assets/orderTest/doctor.svg"
        alt="doctor"
      >
    </template>
  </el-popover>
</template>

<script>
export default {
  props: {
    details: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped>
.rating {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 10px;
  text-align: center;
  color: #FFFFFF;
}

.star-icon {
  color: #FFC107;
  font-size: 14px;
}

.subtitle {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #979797;
}

.content {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #FFFFFF;
  word-break: normal;
}
</style>
